import React from 'react';
import StickyHeader from '../components/StickyHeader';
import Footer from '../components/Footer';
import { Mail, Clock, MessageSquare } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Sticky Navigation */}
      <StickyHeader />

      {/* Hero */}
      <section className="py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-8 max-w-3xl">
          <h1 className="text-4xl md:text-5xl font-semibold tracking-tight mb-6">
            Contact us
          </h1>
          <p className="text-xl text-slate-600 leading-relaxed">
            We're here to help with your compliance questions.
          </p>
        </div>
      </section>

      {/* Contact Cards */}
      <section className="pb-24">
        <div className="container mx-auto px-4 md:px-8 max-w-3xl">
          <div className="space-y-6">
            
            {/* Support */}
            <div className="p-6 border border-slate-200 rounded-xl">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-slate-100 rounded-lg">
                  <MessageSquare className="h-5 w-5 text-slate-700" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-slate-900 mb-2">Support</h2>
                  <p className="text-slate-600 text-sm mb-4">
                    Questions about your account, filings, or services? Our support team can help.
                  </p>
                  <a 
                    href="mailto:support@complykit.in" 
                    className="text-slate-900 font-medium hover:underline"
                  >
                    support@complykit.in
                  </a>
                </div>
              </div>
            </div>

            {/* Business */}
            <div className="p-6 border border-slate-200 rounded-xl">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-slate-100 rounded-lg">
                  <Mail className="h-5 w-5 text-slate-700" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-slate-900 mb-2">Business inquiries</h2>
                  <p className="text-slate-600 text-sm mb-4">
                    Partnerships, enterprise plans, or media queries.
                  </p>
                  <a 
                    href="mailto:hello@complykit.in" 
                    className="text-slate-900 font-medium hover:underline"
                  >
                    hello@complykit.in
                  </a>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div className="p-6 border border-slate-200 rounded-xl">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-slate-100 rounded-lg">
                  <Clock className="h-5 w-5 text-slate-700" />
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-slate-900 mb-2">Working hours</h2>
                  <p className="text-slate-600 text-sm mb-2">
                    Monday to Saturday
                  </p>
                  <p className="text-slate-900 font-medium mb-4">
                    10:00 AM – 7:00 PM IST
                  </p>
                  <p className="text-slate-500 text-sm">
                    Closed on Sundays and national holidays
                  </p>
                </div>
              </div>
            </div>

          </div>

          {/* Response time note */}
          <div className="mt-8 p-4 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">
              <strong className="text-slate-900">Response times:</strong> We typically respond to 
              support queries within 24 hours on working days. During peak filing seasons, 
              responses may take up to 48 hours. Urgent matters related to active filings 
              are prioritized.
            </p>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;
